import styled from 'styled-components';

const QuestionContainer = styled.ol`
  list-style: none;
  padding: 0;
`;

export default QuestionContainer;
